import MarkerClusterer from '@googlemaps/markerclustererplus';
import CustomMarker from './custom-marker';
import { clusterMarkerIcons } from '../map-config';
const images = require.context('../../../images/logotypes', true);

const LocationHandler = {

    markers: [],
    markerCluster: null,

    createMarker: (map, maps, center, onClick, unit, customMarkerStyles) => {
        //if (options) options.icon.scaledSize = new maps.Size(36, 45);
        let src = null;
        try {
            src = images(`./${unit.chainCode}.png`);
        } catch {
            src = null;
        }

        let styles = {};
        if (customMarkerStyles) {
          styles = customMarkerStyles;
        }

        let marker = CustomMarker({
          maps,
          latlng: center,
          map,
          html: src ? `<div class="custom-marker" style=${styles}><div class="custom-marker__logo"><img src=${src} alt="" /></div></div>` : `<div class="custom-marker" style=${styles}><div class="custom-marker__logo"></div></div>`,
          unit
        });
        
        /*const marker = new maps.Marker({
          position: center,
          visible: false,
          map,
          ...options,
        });*/
    
        if (onClick) {
          maps.event.addListener(marker, 'click', (event) => {
            onClick({ units: [unit] });
            event.stopPropagation();
          });
        }
          
        return marker;
    },

    fitBounds: (map, maps) => {
      const bounds = new maps.LatLngBounds();
      LocationHandler.markers.forEach(m => {
        bounds.extend(m.getPosition());
      });
      
      map.setCenter(bounds.getCenter());
      map.fitBounds(bounds);

    },
    

    processMarkerData: (map, maps, locations, disableFitBounds, onClick, cb, createCluster, customMarkerStyles, batchIteration, resolve, bounds = null) => {
        if (!bounds) bounds = new maps.LatLngBounds();
    
        const batchedLocations = locations.splice(0, batchIteration);

        if (!batchedLocations.length) {
          //if (this.props.Locations.length > 0 && !this.props.disableFitBounds) {
            //Set center to fit all markers
            if (!disableFitBounds) {
              map.setCenter(bounds.getCenter());
              map.fitBounds(bounds);
            }
            
          //}

          if (createCluster) {
            LocationHandler.createCulsters(map, maps, LocationHandler.markers, onClick, cb);
          } else {
            // Utan kluster: visa alla markers direkt
            LocationHandler.markers.forEach(marker => {
                if (marker && marker.setMap) {
                    marker.setMap(map);
                }
            });
            if (cb) cb();
          }
         
          //return resolved promise
          return resolve();
        }
    
        requestAnimationFrame(() => {
            batchedLocations.forEach(locationData => {
                if (!locationData.latitude || !locationData.longitude) return;
    
                const marker = LocationHandler.createMarker(
                    map,
                    maps,
                    new maps.LatLng(
                        locationData.latitude,
                        locationData.longitude
                    ),
                    onClick,
                    locationData,
                    customMarkerStyles
                );
                
                if (!createCluster) {
                  marker.setMap(map);
                }

                //Save markers
                LocationHandler.markers.push(marker);
                bounds.extend(marker.getPosition());
            });
    
            LocationHandler.processMarkerData(map, maps, locations, disableFitBounds, onClick, cb, createCluster, customMarkerStyles, batchIteration, resolve, bounds);
        });
    },

    createCulsters: (map, maps, locations, onClick, cb) => {
        const styles = clusterMarkerIcons();
        
        const clusterStyles = styles.map(style => ({
            className: 'unit-cluster', // Använd CSS-klassen som centrerar texten med flexbox
            height: style.height,
            width: style.width,
            textColor: style.textColor || '#fff',
            textSize: style.textSize || 12,
            textLineHeight: style.height, // Sätt line-height till samma som height för vertikal centrering
            anchorText: [0, 0], // Centrera texten horisontellt och vertikalt (default är [0, 0])
            anchorIcon: [style.height / 2, style.width / 2] // Centrera ikonen
        }));

        LocationHandler.markerCluster = new MarkerClusterer(map, locations, {
            styles: clusterStyles,
            gridSize: 60,
            minimumClusterSize: 5
        });

        maps.event.addListener(LocationHandler.markerCluster, 'clusteringend', () => {
            if (cb) cb();
        });

        maps.event.addListener(LocationHandler.markerCluster, 'clusterclick', (cluster) => {
            if (map.getZoom() > 17) {
                const units = cluster.getMarkers().map(marker => marker.unit).filter(Boolean);
                if (units.length > 0) {
                    onClick({ units });
                }
            }
        });
    },

    removeMarkers() {
        if (LocationHandler.markerCluster) {
            LocationHandler.markerCluster.removeMarkers(LocationHandler.markers);
            LocationHandler.markerCluster = null;
        }
        
        LocationHandler.markers.forEach(marker => {
            if (marker && marker.setMap) {
                marker.setMap(null);
            }
        });
        
        LocationHandler.markers = [];
    },

    removeMarkersWithoutClusters() {
      if (LocationHandler.markers) {
        LocationHandler.markers.forEach(marker => {
          marker.setMap(null);
        });
      }
    },

    createLocations: async ({
        map,
        maps,
        units,
        onUnitsLoaded,
        onLoadingComplete,
        disableFitBounds,
        onClick,
        useClusters = true,
        markerStyle = null,
        batchSize = 250
    }) => {
        LocationHandler.removeMarkers();

        if (!units || units.length === 0) {
            if (onLoadingComplete) onLoadingComplete();
            return;
        }

        try {
            const bounds = new maps.LatLngBounds();
            const locationsQueue = [...units];

            await new Promise((resolve) => {
                LocationHandler.processMarkerData(
                    map,
                    maps,
                    locationsQueue,
                    disableFitBounds,
                    onClick,
                    useClusters
                        ? () => {
                            if (onLoadingComplete) onLoadingComplete();
                        }
                        : null,
                    useClusters,
                    markerStyle,
                    batchSize,
                    resolve,
                    bounds
                );
            });

            if (!useClusters && onLoadingComplete) {
                onLoadingComplete();
            }
        } catch (error) {
            console.error('Error creating locations:', error);
            if (onLoadingComplete) onLoadingComplete();
        }
    }
};

export default LocationHandler;